import { inject, observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { updateSearch } from 'bernie-core';
import { ContactHost } from '@shared-ui/retail-lodging-contact-host';
import { useExperiment } from '@shared-ui/experiment-context';
import { useLocalization } from '@shared-ui/localization-context';
import { InfositeQueryAdapter } from 'stores/adapters/infosite-query-adapter';
import { DateUtils } from 'src/common/utils/date-utils';
import { isPetsAmenityFilterPresent } from 'src/common/utils/pets-utils';
import { PropertyFilterAmenity } from 'src/common/__generated__/api';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
const ContactHostWrapper = inject('context', 'currentHotel')(observer(({
  context,
  currentHotel,
  inputs,
  prominence
}) => {
  const l10n = useLocalization();
  const history = useHistory();
  const location = useLocation();
  const {
    exposure: vrboAddAvailCalendartoInquiryform
  } = useExperiment('Vrbo_Add_Avail_Calendar_to_Inquiry_form');
  const updateFilter = payload => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const currentSearchCriteria = currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.searchCriteria;
    if (currentHotel && currentSearchCriteria && vrboAddAvailCalendartoInquiryform.bucket === 0) {
      const params = Object.assign(Object.assign({}, currentSearchCriteria), {
        rooms: payload.rooms,
        amenities: payload.petsIncluded ? PropertyFilterAmenity.PETS : null,
        // eslint-disable-next-line camelcase
        house_rules_group: payload.petsIncluded ? 'pets_allowed' : null,
        localDateFormat: context === null || context === void 0 ? void 0 : context.localDateFormat
      });
      const newParams = InfositeQueryAdapter.parseOut(params, l10n);
      const adults = (_b = (_a = params.rooms) === null || _a === void 0 ? void 0 : _a.reduce((count, room) => count + (room.adults || 0), 0)) !== null && _b !== void 0 ? _b : 0;
      const children = (_d = (_c = params.rooms) === null || _c === void 0 ? void 0 : _c.flatMap((room, roomIndex) => {
        var _a, _b;
        return (_b = (_a = room.children) === null || _a === void 0 ? void 0 : _a.map(({
          age
        }) => `${roomIndex + 1}_${age}`)) !== null && _b !== void 0 ? _b : [];
      })) !== null && _d !== void 0 ? _d : [];
      setTimeout(() => updateSearch({
        location,
        history,
        newParams,
        replace: true
      }), 50);
      currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.setOfferData({
        adults,
        children: children.join(','),
        petsIncluded: payload.petsIncluded
      });
      currentHotel.showPetsOnSingleOffer = payload.petsIncluded;
    }
    if (currentHotel && currentSearchCriteria && vrboAddAvailCalendartoInquiryform.bucket === 1) {
      const {
        dateChange,
        rooms,
        petsIncluded,
        dateRange
      } = payload;
      const startDate = DateUtils.parseStringDate(dateRange === null || dateRange === void 0 ? void 0 : dateRange.selectedStartDate);
      const endDate = DateUtils.parseStringDate(dateRange === null || dateRange === void 0 ? void 0 : dateRange.selectedEndDate);
      const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, currentSearchCriteria), {
        rooms: rooms || inputs.searchCriteria.primary.rooms
      }), rooms && {
        amenities: petsIncluded ? PropertyFilterAmenity.PETS : null,
        // eslint-disable-next-line camelcase
        house_rules_group: petsIncluded ? 'pets_allowed' : null
      }), {
        localDateFormat: context === null || context === void 0 ? void 0 : context.localDateFormat
      }), dateChange && {
        startDate: startDate,
        endDate: endDate,
        _startDate: startDate,
        _endDate: endDate
      });
      const newParams = InfositeQueryAdapter.parseOut(params, l10n);
      const adults = (_f = (_e = params.rooms) === null || _e === void 0 ? void 0 : _e.reduce((count, room) => count + (room.adults || 0), 0)) !== null && _f !== void 0 ? _f : 0;
      const children = (_h = (_g = params.rooms) === null || _g === void 0 ? void 0 : _g.flatMap((room, roomIndex) => {
        var _a, _b;
        return (_b = (_a = room.children) === null || _a === void 0 ? void 0 : _a.map(({
          age
        }) => `${roomIndex + 1}_${age}`)) !== null && _b !== void 0 ? _b : [];
      })) !== null && _h !== void 0 ? _h : [];
      setTimeout(() => updateSearch({
        location,
        history,
        newParams,
        replace: true
      }), 50);
      currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.setOfferData(Object.assign({
        adults,
        children: children.join(','),
        petsIncluded: petsIncluded
      }, dateChange && {
        startDate: startDate,
        endDate: endDate
      }));
      currentHotel.showPetsOnSingleOffer = petsIncluded;
    }
  };
  const contactHostInput = {
    primaryPropertyCriteriaInput: {
      rooms: inputs.searchCriteria.primary.rooms,
      destination: {
        propertyIds: [inputs.propertyId]
      },
      dateRange: inputs.searchCriteria.primary.dateRange
    },
    petsIncluded: isPetsAmenityFilterPresent(context, currentHotel)
  };
  const contactHostInputWithProminence = {
    prominence,
    inquiryFormInput: contactHostInput
  };
  const ref = React.useRef(null);
  return React.createElement(ContactHost, {
    inputs: contactHostInputWithProminence,
    inputsOffer: inputs,
    onFieldsChangeCallback: updateFilter,
    triggerRef: ref,
    skipSsr: true
  });
}));
export const SharedUiContactHostWrapper = withSharedUiPropertyOffers(ContactHostWrapper);
SharedUiContactHostWrapper.displayName = 'SharedUiContactHostWrapper';